import { useEffect, useState } from "react";

export function useObserveElement(
  targetSelector,
  onVisibleCallback,
  threshold = 0.1
) {
  const [targetVisible, setTargetVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTargetVisible(true);
            if (onVisibleCallback) {
              onVisibleCallback(); // Execute any callback passed once the element becomes visible
            }
          }
        });
      },
      { threshold }
    );

    const mutationObserver = new MutationObserver(() => {
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        observer.observe(targetElement);
      }
    });

    // Start observing the body (or any specific container where elements are added)
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      // Clean up observers when the component unmounts
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [targetSelector, onVisibleCallback, threshold]);

  return targetVisible;
}
